import { getTodayDate } from 'utils'

export const isPurchaseDateInTheFuture = (dateToValidate: { month: number; year: number }) => {
  const today = getTodayDate()
  const currentYear = today.getFullYear()
  // Returned month is 0 indexed
  const currentMonth = today.getMonth() + 1

  if (currentYear < dateToValidate.year) {
    return true
  } else if (currentYear === dateToValidate.year && currentMonth < dateToValidate.month) {
    return true
  }

  return false
}
